import { Button } from "@mui/material";
import QRCode from "react-qr-code";
import { useParams } from "react-router-dom";

export const CngGogasQR = () => {
    const params = useParams();
    const details = params.details
    return (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "90vh", padding: "20px", gap: "24px" }}>
            <h3>Scan QR Code to pay for your CNG</h3>
            <QRCode
                value={"@" + details}
                viewBox={`0 0 256 256`}
                level="H"
            />
            <Button variant="contained" color="primary">Check payment status</Button>
        </div>
    )
}